import * as React from "react";
import { moreMenuItems } from "../nav.tsx";
import { MoreMenuItem } from "./MoreMenuItem.tsx";

export const MoreMenuItems: React.FC = () => {
  return (
    <div>
      {moreMenuItems.map((item) => (
        <MoreMenuItem key={item.label} item={item} />
      ))}
    </div>
  );
};
